import { Collection, Empty } from '../../reducers/types/reducerTypes'
import {
  LiveCard,
  ShowCard,
  VideoCard,
  SeasonCard,
  CollectionCard,
  EmptyCard,
} from '../Card'
import { CardProps } from '../Card/types'

import type { CardLayouts, CarouselType, Layout } from './types'

const cardLayouts: Omit<CardLayouts, 'card3x4SLayout'> = {
  card16x9SLayout: {
    cardWidth: 487,
    cardHeight: 274,
    cardMarginRight: 55,
    screenVisibleItems: 4,
    carouselMarginBottom: 250,
  },
  card16x9MLayout: {
    cardWidth: 633,
    cardHeight: 356,
    cardMarginRight: 55,
    screenVisibleItems: 3,
    carouselMarginBottom: 250,
  },
  card3x4MLayout: {
    cardWidth: 260,
    cardHeight: 390,
    cardMarginRight: 55,
    screenVisibleItems: 6,
    carouselMarginBottom: 40,
  },
}

const getCarouselType = <T>({
  item_type,
  slug,
  content,
}: Collection<T>): CarouselType | undefined => {
  if (content && (content[0] as Empty)?.empty_set) {
    return 'empty'
  }
  switch (item_type) {
    case 'schedule':
      return 'live'
    case 'video':
      return slug === 'spotlight-with-local-video' ? 'spotlight-video' : 'video'
    case 'show':
      return 'show'
    case 'multiple':
      return slug === 'show-results' ? 'show' : 'video'
    case 'season':
      return 'season'
    case 'skylab-collection':
      return 'skylab-collection'
  }
}

export const getCard = <T>(
  collection: Collection<T>
): React.FC<CardProps<any>> => {
  switch (getCarouselType(collection)) {
    case 'empty':
      return EmptyCard
    case 'live':
      return LiveCard
    case 'video':
    case 'spotlight-video':
      return VideoCard
    case 'season':
      return SeasonCard
    case 'skylab-collection':
      return CollectionCard
    case 'show':
    default:
      return ShowCard
  }
}

export const getCarouselLayout = <T>(collection: Collection<T>): Layout => {
  switch (getCarouselType(collection)) {
    case 'empty':
      return {
        ...cardLayouts.card3x4MLayout,
        cardWidth: 488,
        screenVisibleItems: 1,
      }
    case 'live':
      return {
        ...cardLayouts.card16x9MLayout,
        carouselMarginBottom: 132,
      }
    case 'spotlight-video':
      return cardLayouts.card16x9MLayout
    case 'video':
      return cardLayouts.card16x9SLayout
    case 'season':
    case 'skylab-collection':
      return {
        ...cardLayouts.card16x9SLayout,
        carouselMarginBottom: 107,
      }
    case 'show':
    default:
      return cardLayouts.card3x4MLayout
  }
}

export const isLive = (carouselSlug: string): boolean =>
  carouselSlug === 'livestream_now'

export const isArrowLeft = (event: KeyboardEvent): boolean => {
  if (event?.key === 'ArrowLeft' || event?.keyCode === 37) {
    return true
  }
  return false
}

export const isArrowRight = (event: KeyboardEvent): boolean => {
  if (event?.key === 'ArrowRight' || event?.keyCode === 39) {
    return true
  }
  return false
}

export { VirtualizedList } from './VirtualizedList'
